module.exports = __webpack_public_path__ + "media/EllaChen.1ee8abe9.mp4";